export const INDEX_META = {
  TITLE: "飲食店の正社員求人・転職はエフジョブ求人",
  DESCRIPTION: "理想の転職を飲食業界のプロと一緒に実現するエフジョブ求人",
  URL: "https://fjob-kyujin.com/",
} as const;
